export enum DictCodeEnmu {
    //门店类型
    SHOP_TYPE = "shop-type",
    //账户类型
    ACC_TYPE = "account-type",
    //供应商类型
    SUPPLIER_TYPE = 'supplier-type',
    //用户类型
    USER_TYPE = "user-type",
    //客户类型
    CUSTOMER_TYPE = 'customer-type',
    //支付方式
    PAY_METHOD = "pay-method",
    //结算类型
    SETTLE_TYPE = "settle-type",
    //结算类型 (挂账)
    SETTLE_TYPE_CREDIT = "settle-type.credit",
    //结算类型 （现结）
    SETTLE_TYPE_CASH = "settle-type.cash",
    //结算类型 （结转）
    SETTLE_TYPE_BALANCE = "settle-type.balance",

    //客户优惠单
    CUSTOMER_DISCOUNT = "favorable-status",
    //授信账户
    ACC_CREDIT = "account-type.credit",
    //应用类型
    APP_TYPE = "app-type",
    //开户银行
    ACC_BACK = "account-back",
    //品牌名称
    BRAND_NAME = "material-brand",
    //配件类型
    MATERIAL_TYPE = "material-type",
    //单位
    UNIT = "unit",
    //合约类型
    CONTRACT_TYPE = "contract-type",

    // //供应链 (销退)
    // SALE_RETURN = "trade-type.sale-return",
    // //供应链 (采退)
    // PURCHASE_RETURN = "trade-type.purchase-return",

}